/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { $ } from 'venuescanner-js/tools/elemental';
// eslint-disable-next-line no-unused-vars
import { node, Html } from 'venuescanner-js/tools/jsx';
// import moment from 'moment'
import { post } from 'venuescanner-js/services/api';
import { popup } from 'venuescanner-js/vanilla/components/popup';
import {
  STRING,
  BOOLEAN,
} from 'venuescanner-js/vanilla/models/ObservablePropTypes';
// this package prevents tabing from any item with a .block-tab class
// eslint-disable-next-line no-unused-vars
import blockTabKey from 'venuescanner-js/helpers/blockTabKey';
// eslint-disable-next-line
import './VirtualEventEnquiryForm.scss';

const TextInput = ({
  type = '',
  name,
  label = '',
  hint = '',
  required,
  value = '',
  dataGa = '',
  autocomplete,
}) => {
  return (
    <vs-input-group
      for={name}
      label={required ? `${label} *` : label}
      hint={hint}
      hasError={true}
      data_ga={dataGa}>
      {type === 'tel' ? (
        <vs-phone
          vsId={name}
          name={name}
          label={label}
          required={required}
          value={value}
          data-ga={dataGa}
          onVschange={e => {
            value.set(e.detail);
          }}
        />
      ) : type === 'textarea' ? (
        <vs-text
          type={type}
          vsId={name}
          name={name}
          label={label}
          required={required}
          autocomplete={true}
          autocompletename={autocomplete}
          value={value}
          data-ga={dataGa}
          blockTab={true}
          onVschange={e => {
            value.set(e.detail);
          }}
        />
      ) : (
        <vs-input
          type={type}
          vsId={name}
          name={name}
          label={label}
          required={required}
          autocomplete={true}
          autocompletename={autocomplete}
          value={value}
          data-ga={dataGa}
          onVschange={e => {
            value.set(e.detail);
          }}
        />
      )}
    </vs-input-group>
  );
};

const SelectInput = ({
  name,
  label,
  hint = '',
  options,
  required = true,
  value,
  dataGa,
}) => {
  return (
    <vs-input-group
      for={name}
      label={required ? `${label} *` : label}
      hint={hint}
      hasError={true}
      data_ga={dataGa}>
      <vs-select
        name={name}
        label={label}
        required={required}
        selectplaceholder={label}
        dataGa={dataGa}
        value={value}
        onVschange={e => {
          value.set(e.detail);
        }}>
        {options.map(l => (
          <vs-option label={l} value={l}></vs-option>
        ))}
      </vs-select>
    </vs-input-group>
  );
};

const VirtualEventEnquiryForm = ({ setIsFormOpen }) => {
  // const today = moment().format('MM/DD/YYYY')
  // const tomorrow = moment().add(1, 'days').format('MM/DD/YYYY')

  // const Budget = new STRING(null, '')
  const Capacity = new STRING(null, '');
  // const Company = new STRING(null, '')
  // const CustomerType = new STRING(null, '')
  const Description = new STRING(null, '');
  const Email = new STRING(null, '');
  // const EventType = new STRING(null, '')
  const Name = new STRING(null, '');
  // const Phone = new STRING(null, '')
  // const Start = new DATE(null, today)
  // const End = new DATE(null, tomorrow)
  const notValid = new BOOLEAN(null, true);

  let sendButton = null;
  const sendForm = async () => {
    sendButton.loading = true;

    const data = {
      interestType: 'Virtual Event',
      capacity: Capacity,
      description: Description,
      email: Email,
      name: Name,
    };
    console.log('data', data);

    const postEnquiry = async () => {
      try {
        return await post('/register-interest', data).then(() => {
          sendButton.loading = false;
          Capacity.set(0);
          Description.set('');
          Email.set('');
          Name.set('');
          notValid.set(true);
          setIsFormOpen(false);
          popup.show(
            <div class='centered'>
              {
                <p>
                  Thankyou for registering your interest, our concierge team
                  will be in contact with you shortly.
                </p>
              }
            </div>,
            { closable: true, success: true },
          );
        });
      } catch (e) {
        sendButton.loading = false;
        setIsFormOpen(false);
        popup.show(
          <div class='centered'>
            {<p>Woops, something went wrong, please try again.</p>}
          </div>,
          { closable: true, success: false },
        );
      }
    };
    postEnquiry();
  };

  const checkValid = () => {
    notValid.set(!Capacity.valueOf() || !Email.valueOf() || !Name.valueOf());
  };

  Capacity.watch(checkValid);
  Description.watch(checkValid);
  Email.watch(checkValid);
  Name.watch(checkValid);
  let container = null;
  const triggerTouched = () => {
    $(container)
      .find('.input-touched')
      .get()
      .forEach(el => {
        el.dispatchEvent(new MouseEvent('click'));
      });
  };

  return (
    <div class='virtual-event-enquiry-form'>
      <form
        ref={el => {
          container = el;
        }}>
        <TextInput
          type='text'
          name='name'
          label='Name'
          required={true}
          value={Name}
          dataGa='virtual_enquiry_name_input_clicked'
        />
        <TextInput
          type='email'
          name='email'
          label='Email'
          required={true}
          value={Email}
          dataGa='virtual_enquiry_email_input_clicked'
        />
        {/* <TextInput
            type="tel"
            name="phone"
            label="Phone"
            required={true}
            value={Phone}
            dataGa="virtual_enquiry_phone_input_clicked"
          /> */}
        {/* <TextInput
            type="text"
            name="company"
            label="Company"
            required={true}
            value={Company}
            dataGa="virtual_enquiry_company_input_clicked"
          /> */}
        {/* <SelectInput
            name="budget"
            label="Budget"
            options = {[
              'Under £250',
              '£250 to £500',
              '£500 to £1,000',
              '£1,000 to £3,000',
              '£3,000 to £6,000',
              '£6,000 to £12,000',
              '£12,000 to £24,000',
              '£25,000 to £50,000',
              'Over £50,000',
              "Sky's the Limit!"
            ]}
            value={Budget}
            dataGa="virtual_enquiry_budget_input_clicked"
          /> */}
        {/* <SelectInput
            name="eventtype"
            label="Event Type"
            options = {[
              'Christmas Party',
              'Team Event',
              'Conference',
              'Webinar',
              'Party',
              'Award Ceremony',
              'Team Building',
              'General Enquiry',
              'Other'
            ]}
            value={EventType}
            dataGa="virtual_enquiry_eventtype_input_clicked"
          /> */}
        <TextInput
          type='text'
          name='capacity'
          label='No. Guests'
          required={true}
          value={Capacity}
          dataGa='virtual_enquiry_capacity_input_clicked'
        />
        {/* <SelectInput
            name="capacity"
            label="No. Guests"
            options = {[
              'Under 30',
              '30 - 50',
              '50 - 100',
              '100 - 200',
              '200 - 300',
              'More than 300'
            ]}
            value={Capacity}
            dataGa="virtual_enquiry_capacity_input_clicked"
          /> */}
        {/* <SelectInput
            name="customertype"
            label="Customer Type"
            options = {[
              'Business',
              'Personal'
            ]}
            value={CustomerType}
            dataGa="virtual_enquiry_customer_input_clicked"
          /> */}

        {/* <div class="date-range">
          <label class="vs-input-group__label">Select your dates</label>
          <vs-daterange
            from={Start}
            to={End}
            onVschange={e => {
              Start.set(e.detail[0])
              End.set(e.detail[1])
            }}
            dataGa="virtual_enquiry_daterange_input_clicked"
          />
        </div> */}

        <TextInput
          type='textarea'
          name='description'
          label='Description'
          required={false}
          value={Description}
          dataGa='virtual_enquiry_description_input_clicked'
        />

        <div class='submit'>
          <vs-btn
            ref={el => {
              sendButton = el;
            }}
            type='primary'
            // disabled={notValid}
            onClick={() => {
              if (notValid.valueOf()) {
                triggerTouched();
              } else {
                sendForm();
              }
            }}>
            Submit Enquiry
          </vs-btn>
        </div>
      </form>
    </div>
  );
};

export const appendVirtualEventForm = (el, setIsFormOpen) =>
  el
    ? $(el).append(<VirtualEventEnquiryForm setIsFormOpen={setIsFormOpen} />)
    : null;

export default VirtualEventEnquiryForm;
